<script>
  import ImagePreview from './ImagePreview.svelte'
  export let mediaUrls
  export let handleRemoveImage
</script>

{#each mediaUrls as file, index (index)}
  <ImagePreview {file} {index} {handleRemoveImage} />
{/each}
